import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const addToCartAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.cartUrl, data).then((response) => {
        callBack && callBack(response?.data, response?.data);
      });
    } catch (err) {
      console.log("add to cart api err===-=>>>:", err);
      throw err;
    }
  };
};

export const getCartAPI = (params, callBack) => {
  return async () => {
    let url = ApiConstants.cartUrl;

    if (params?.manufacturer_id) {
      url += `?manufacturer_id=${params.manufacturer_id}`;
    }
    try {
      await apiGet(url, params).then((response) => {
        callBack && callBack(response, response);
      });
    } catch (err) {
      console.log("get cart api err===-=>>>:", err);
      throw err;
    }
  };
};
export const getCartBrandsAPI = (params, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.cartBrandUrl, params).then((response) => {
        callBack && callBack(response, response);
      });
    } catch (err) {
      console.log("get cart api err===-=>>>:", err);
      throw err;
    }
  };
};
export const getCartTotalAPI = (params, callBack) => {
  return async () => {
    try {
      const { gold_rate, silver_rate, manufacturer_id } = params;
      const url = `${ApiConstants.cartTotalUrl}?gold_rate=${gold_rate}&silver_rate=${silver_rate}&manufacturer_id=${manufacturer_id}`;

      await apiGet(url).then((response) => {
        callBack && callBack(response, response);
      });
    } catch (err) {
      console.log("get cart total api err===-=>>>:", err);
      throw err;
    }
  };
};


export const updateQuantityInCartAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.cartUrl, data).then((response) => {
        callBack && callBack(response?.data, response?.data);
      });
    } catch (err) {
      console.log("update quantity in cart api err===-=>>>:", err);
      throw err;
    }
  };
};

export const deleteItemFromCartAPI = (data, callBack) => {
  return async () => {
    try {
      await apiDelete(`${ApiConstants.cartUrl}/?cart_id=${data}`).then(
        (response) => {
          callBack && callBack(response?.data, response?.data);
        }
      );
    } catch (err) {
      console.log("delete item from cart api err===-=>>>:", err);
      throw err;
    }
  };
};
